<template>
  <v-app id="app">
    <v-app-bar app elevate-on-scroll dense class="grey darken-3 bottom-gradient">
      <!-- -->
      <v-icon color="#eebf33">fab fa-medapps</v-icon>
      <v-toolbar-title class="white--text">
        <strong class="pl-3">Vivid</strong> Financing
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn
        v-if="authState === 'signedIn'"
        class="text-right"
        rounded
        small
        @click="signOut()"
      >Sign Out</v-btn>
      <template v-slot:extension>
        <v-row justify="center" no-gutters>
          <v-btn v-for="link in links" :key="link.label" :to="link.path"
          color="white" text rounded class="my-2">{{ link.label }}
          </v-btn>
        </v-row>
      </template>
    </v-app-bar>

    <!-- Sizes your content based upon application components -->
    <v-content>
      <!-- If using vue-router -->
      <router-view id="viewbg"></router-view>
    </v-content>

    <!-- Footer -->
    <v-footer color="grey darken-3" padless>
      <v-row justify="center" no-gutters class="top-gradient">
        <v-btn v-for="link in links" :key="link.label" :to="link.path"
         color="white" text rounded class="my-2">{{ link.label }}
        </v-btn>
        <v-col class="grey darken-4 py-4 text-center white--text" cols="12">
          {{ new Date().getFullYear() }} —
          <v-icon color="#eebf33">fab fa-medapps</v-icon>
          <strong class="pl-2">Vivid</strong> Financing
        </v-col>
      </v-row>
    </v-footer>
  </v-app>
</template>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  background-color: #000000;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #090c11;
}

#nav a.router-link-exact-active {
  color: #42b983;
}

#viewbg {
  background-image: url("/light-bulb-4514505.png");
  background-size: auto 670px;
  background-position: center top;
}

.bottom-gradient {
    background-image: linear-gradient(to top, rgba(0, 0, 0, 0.4) 0%, transparent 72px);
}

.top-gradient {
    background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0.4) 0%, transparent 72px);
}

h1.display-1, h1.display-3 {
  color: #eebf33;
}
</style>

<script>
import { mapActions, mapState } from 'vuex';

export default {
  data: () => ({
    links: [
      {
        label: 'Home',
        path: '/',
      },
      {
        label: 'Application',
        path: '/application',
      },
      {
        label: 'Contact Us',
        path: '/contact',
      },
      {
        label: 'Small Business Funding',
        path: '/loans',
      },
      {
        label: 'Reach Investors',
        path: '/investors',
      },
    ],
  }),
  methods: {
    ...mapActions({
      signOut: 'signOut',
    }),
  },
  computed: {
    ...mapState({
      authState: (state) => state.currentAuthState,
    }),
  },
};
</script>
